"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dependencies_1 = require("./dependencies");
const def = {
    keyword: "dependentSchemas",
    type: "object",
    schemaType: "object",
    code: (cxt) => dependencies_1.validateSchemaDeps(cxt),
};
exports.default = def;
//# sourceMappingURL=dependentSchemas.js.map